import { useMemo } from 'react';
import { useTypedAggregatorClient } from '../../aggregator-client-context/aggregator-client-context';
import { PLACEHOLDER_EXPERIENCE } from '../../aggregator-client-context';
import { type PermissionSupplier } from '../../product-router/product/check-product-permissions';
import {
	type AggregatorBitbucketResponse,
	type BitbucketScope,
	BITBUCKET_PRODUCT_ID,
} from './types';

export const useBitbucketPermissionSupplier: (overridenPermissionsSupplier?: PermissionSupplier) => PermissionSupplier = (
	overridenPermissionsSupplier?: PermissionSupplier,
) => {
	const client = useTypedAggregatorClient<AggregatorBitbucketResponse, BitbucketScope>();

	return useMemo(() => {
		if (overridenPermissionsSupplier) {
			return overridenPermissionsSupplier;
		}

		return () =>
			(client?.getProductScopes(BITBUCKET_PRODUCT_ID, PLACEHOLDER_EXPERIENCE) || []) as Promise<
				string[]
			>;
	}, [client, overridenPermissionsSupplier]);
};
